module.exports = __webpack_public_path__ + "img/fundermax-obra-1-1.cc213602.jpg";